import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
  {
    heading: 'Agreement',
    paragraphs: [
      'These Terms of Service form an agreement between Upgraded Technologies Inc. and the customer using getupgraded.ai, getupgraded.ca, app.getupgraded.ca, or related services. By using the services you agree to these terms. If you do not agree, stop using the services.',
    ],
  },
  {
    heading: 'Services and restrictions',
    paragraphs: [
      'We provide SaaS tools and optional professional services for grants, savings, and automations. You may use the services for internal business purposes in Canada and the United States. You may not resell, reverse engineer, probe, or use the services to build a competing product.',
    ],
  },
  {
    heading: 'Fees, refunds, and guarantees',
    paragraphs: [
      'Fees are described on your sign-up or order form. Professional services for awarded grant funds are typically 20% of awarded funds unless otherwise agreed. Guarantee claims, including savings guarantees, require an active paid subscription for at least 12 consecutive months and full participation in onboarding. Billing disputes must be emailed to support@getupgraded.ca within 30 days of the charge.',
      'The money-back guarantee for platform subscriptions is described at /moneyback-guarantee.',
    ],
  },
  {
    heading: 'Liability',
    paragraphs: [
      'The services are provided as-is. Grant decisions are made by funding bodies, not Upgraded. Our aggregate liability is limited to the greater of $1,000 or fees paid in the prior 12 months. These terms are governed by the laws of British Columbia.',
    ],
  },
];

export default function TermsOfServicePage() {
  return <LegalPage title="Terms of service" updated="June 5, 2024" sections={SECTIONS} />;
}
